/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileZipx = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M20 7.586V10h-2V9h-5V4H6v16h12v-1h2v3H4V2h10.414zM15 7h1.586L15 5.414z" />
        <path d="m11.678 12.729-2.374 3.36h2.464V17H7.945v-.766l2.36-3.34H8.029v-.91h3.65zM13.567 17h-1.076v-5.017h1.076zm2.773-5.017c.617 0 1.082.143 1.394.428.318.285.476.709.476 1.27 0 .372-.071.685-.214.938a1.327 1.327 0 0 1-.628.566c-.276.13-.618.194-1.027.194h-.725V17h-1.07v-5.017zm-.724 2.519h.504c.368 0 .628-.062.78-.187.156-.128.234-.34.234-.634 0-.3-.078-.511-.235-.635-.151-.124-.411-.186-.779-.186h-.504zm5.006-.784 1.008-1.735h1.186l-1.476 2.432L22.893 17h-1.236l-1.119-1.897L19.463 17h-1.187l1.547-2.603-1.47-2.414h1.234z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileZipx as FileZipx };
